import { render, staticRenderFns } from "./SourceTable.vue?vue&type=template&id=0a982378&scoped=true"
import script from "./SourceTable.vue?vue&type=script&lang=ts"
export * from "./SourceTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a982378",
  null
  
)

export default component.exports